import { Network, ERC1155_SUBGRAPH, ERC721_SUBGRAPH, NFTX_SUBGRAPH, NON_STANDARD_SUBGRAPH, NFTX_UNISWAP_SUBGRAPH, NFTX_ROUTER_URL, NFTX_APR_URL, NFTX_API_URL } from '@nftx/constants';
import merge from 'deepmerge';

/** Configuration settings for nftx.js */

const storeSetting = (obj, propertyName, storageKey, value) => {
  if (typeof window === 'undefined' || typeof window?.localStorage?.getItem !== 'function') {
    return;
  }
  if (value && typeof value === 'object') {
    Object.entries(value).forEach(([k, v]) => {
      const key = `${storageKey}_${k}`;
      storeSetting(value, k, key, v);
    });
    return;
  }
  let defaultValue = JSON.stringify(value);
  const key = `nftxjs_itl_${storageKey}`;
  Object.defineProperty(obj, propertyName, {
    configurable: true,
    enumerable: true,
    get() {
      return JSON.parse(window.localStorage.getItem(key) ?? defaultValue);
    },
    set(v) {
      const formatted = JSON.stringify(v);
      defaultValue = formatted;
      window.localStorage.setItem(key, formatted);
    }
  });
};
const storeSettings = obj => {
  Object.entries(obj).forEach(([key, value]) => {
    storeSetting(obj, key, key, value);
  });
};
const defaultConfig = {
  network: Network.Mainnet,
  debug: false,
  subgraph: {
    ERC1155_SUBGRAPH,
    ERC721_SUBGRAPH,
    NFTX_SUBGRAPH,
    NON_STANDARD_SUBGRAPH,
    NFTX_UNISWAP_SUBGRAPH
  },
  urls: {
    NFTX_ROUTER_URL,
    NFTX_APR_URL,
    NFTX_API_URL
  },
  contracts: {
    ethPrice: {
      [Network.Sepolia]: '2000000000' // $2k
    }
  },
  keys: {
    NFTX_API: null,
    RESERVOIR: {}
  },
  internal: {
    source: 'api',
    requiredBlockNumber: {
      [Network.Mainnet]: 0,
      [Network.Sepolia]: 0,
      [Network.Arbitrum]: 0,
      [Network.Base]: 0
    },
    apiBlockNumber: {
      [Network.Mainnet]: 0,
      [Network.Sepolia]: 0,
      [Network.Arbitrum]: 0,
      [Network.Base]: 0
    },
    blockBuffer: 10
  }
};
/**
 * Configuration settings for nftx.js
 */
const config = {
  ...defaultConfig,
  /**
   * Set a series of options
   * You can pass in a combination of partial options and they will be merged into the previous configuration
   */
  configure(opts) {
    const merged = merge(config, opts, {
      arrayMerge: (_, arr) => arr
    });
    storeSettings(merged.internal);
    Object.entries(merged).forEach(([key, value]) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      config[key] = value;
    });
  }
};
config.configure(defaultConfig);

export { config as default };
